import script from "./base-editable-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./base-editable-tabs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__